import React, {useState, useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const removeIcon = require("./../assets/img/remove-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const uploadImg = require("./../assets/img/upload-button.svg").default;
const searchIcon = require("./../assets/img/search-icon.svg").default;
const EditIcon = require("./../assets/img/edit-icon.svg").default;

const ViewUsers = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [fileData, setFileData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]); // Add this line
  const [showPopup, setShowPopup] = useState(false); // Add this line
  const filesPerPage = 5; // Number of files to display per page
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [fileToRemove, setFileToRemove] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [pageNumber, setPageNumber] = useState("1");
  const [pageLimit, setPageLimit] = useState("5");
  const [totalRecord, setTotalRecord] = useState(0);
  const [timer, setTimer] = useState(null);
  const [userList, setUserList] = useState([]);
  const [showActiveStatusModal, setShowActiveStatusModal] = useState(false);
  const [showDeactiveStatusModal, setShowDeactiveStatusModal] = useState(false);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    // fetchAllFiles(storedUserData);
  }, []);

  const handleCheckboxChange = (event, fileName) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedFiles(prevSelectedFiles => [...prevSelectedFiles, fileName]);
    } else {
      setSelectedFiles(prevSelectedFiles => prevSelectedFiles.filter(file => file !== fileName));
    }
  };

  const delayExecution = (callback, ms) => {
    clearTimeout(timer);
    const newTimer = setTimeout(callback, ms);
    setTimer(newTimer);
  };

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
    setPageNumber(pageNumber);
    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchChange = event => {
    setSearchKey(event.target.value);

    delayExecution(() => {
      formDataSubmit(pageNumber, event.target.value);
    }, 500);
  };

  const handleFilterButtonClick = () => {
    setShowPopup(prevShowPopup => !prevShowPopup);
  };

  const formDataSubmit = (pageNumber, searchKey) => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Construct the URL with from_date and to_date parameters
    const form = new FormData();
    // form.append("from_date", fromDate);
    // form.append("to_date", toDate);
    // form.append("search_key", searchKey);
    form.append("page_no", pageNumber);
    form.append("limit", pageLimit);

    fetch(`https://cliqestimatebuilder.com/waiver_admin/users/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "GET",
    })
      .then(response => response.json())
      .then(data => {
        if (data.data && Array.isArray(data.data)) {
          setFileData(data.data);

          // Check if totalRecord exists in the data object
          if ("totalRecord" in data) {
            setTotalRecord(data.totalRecord);
          } else {
            setTotalRecord(0); // Set totalRecord to 0 if it's not present in response
          }
        } else {
          setFileData([]);
          setTotalRecord(0);
          console.error("Received data is not in the expected format:", data);
        }
      })
      .catch(error => console.error("Error fetching file data:", error));
  };

  const fetchAllFiles = storedUserData => {
    formDataSubmit(pageNumber, searchKey);
  };

  const handlePopupSubmit = event => {
    event.preventDefault();
    setShowPopup(false); // Close the popup
    setCurrentPage(1); // Reset to the first page

    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchSubmit = event => {
    event.preventDefault();
    setCurrentPage(1); // Reset to the first page
    formDataSubmit(pageNumber, searchKey);
  };

  const showPagination = Math.ceil(totalRecord / filesPerPage);

  const totalPages = Math.ceil(totalRecord / filesPerPage); // Calculate total pages

  const handleRemoveClick = (index, fileId) => {
    setFileToRemove({index, fileId});
    setShowConfirmationModal(true);
  };

  const handleActiveStatusClick = (index, fileId) => {
    setFileToRemove({index, fileId});
    setShowActiveStatusModal(true);
  };

  const handleDeactivateStatusClick = (index, fileId) => {
    setFileToRemove({index, fileId});
    setShowDeactiveStatusModal(true);
  };

  const deleteUser = () => {
    if (fileToRemove) {
      const {index, fileId} = fileToRemove;
      let copyArray = [...userList];
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      const formData = new FormData();
      formData.append("id", fileId);

      fetch(`https://cliqestimatebuilder.com/waiver_admin/users/${fileId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.res == 1) {
            // Update the file list by removing the file at the specified index
            copyArray.splice(index, 1);
            setUserList(copyArray);
            // fetchAllFiles(storedUserData);
          } else {
            if (data.error) {
              console.error("Error deleting file:", data.error);
              // Handle the error condition if required
            } else {
              console.error("Error deleting file: Unknown error");
              // Handle other types of errors
            }
          }
        })
        .catch(error => console.error("Error changing delete status:", error));

      setShowConfirmationModal(false);
      setFileToRemove(null);
    }
  };

  const deactivateUser = () => {
    if (fileToRemove) {
      const {index, fileId} = fileToRemove;
      let copyArray = [...userList];
      let selectedRow = copyArray[index];
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      const formData = new FormData();
      formData.append("status", 2);
      fetch(`https://cliqestimatebuilder.com/waiver_admin/users/${fileId}`, {
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        method: "PUT",
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.res == 1) {
            // fetchAllFiles(storedUserData);
            selectedRow.status = 2;
            let updatedArray = copyArray;
            setUserList(updatedArray);
          } else {
          }
        })
        .catch(error => {
          console.error("Error fetching file data:", error);
        });

      setShowDeactiveStatusModal(false);
      setFileToRemove(null);
    }
  };

  const activateUser = () => {
    if (fileToRemove) {
      const {index, fileId} = fileToRemove;
      let copyArray = [...userList];
      let selectedRow = copyArray[index];
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      const formData = new FormData();
      formData.append("status", 1);
      fetch(`https://cliqestimatebuilder.com/waiver_admin/users/${fileId}`, {
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        method: "PUT",
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.res == 1) {
            // fetchAllFiles(storedUserData);
            selectedRow.status = 1;
            let updatedArray = copyArray;
            setUserList(updatedArray);
          } else {
          }
        })
        .catch(error => {
          console.error("Error fetching file data:", error);
        });

      setShowActiveStatusModal(false);
      setFileToRemove(null);
    }
  };

  const fetchUserList = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    fetch(`https://cliqestimatebuilder.com/waiver_admin/users/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "GET",
    })
      .then(response => response.json())
      .then(data => {
        if (data.data && Array.isArray(data.data)) {
          setUserList(data.data);
          // Check if totalRecord exists in the data object
          if ("totalRecord" in data) {
            setTotalRecord(data.totalRecord);
          } else {
            setTotalRecord(0); // Set totalRecord to 0 if it's not present in response
          }
        } else {
          setUserList([]);
          setTotalRecord(0);
          console.error("Received data is not in the expected format:", data);
        }
      })
      .catch(error => console.error("Error fetching file data:", error));
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewOne">
            <div className="viewOneLeft">
              <h2>All Users</h2>
            </div>
            <div className="viewOneRight">
              <Link to="/create-user" className="createFormBtn vwOneBtn iconNone">
                Create user
              </Link>
            </div>
          </div>
          <div className="viewBox">
            <div className="viewFileList">
              <h3>Total {userList?.length > 0 ? userList?.length : 0} users</h3>
              <div className="listing viewTbl userListing">
                <table>
                  <thead>
                    <tr>
                      {/* <th></th> */}
                      {/* <th>Avatar</th> */}
                      <th>Name</th>
                      <th>Email</th>
                      <th>Created by</th>
                      <th></th>
                    </tr>
                  </thead>
                  {userList?.length > 0 ? (
                    <tbody>
                      {userList.map((file, index) => (
                        <tr key={index} className={selectedFiles.includes(file.file_name) ? "active" : ""}>
                          {/* <td className="checkWidth">
                            <input type="checkbox" onChange={event => handleCheckboxChange(event, file.file_name)} />
                          </td> */}
                          {/* <td className="countWidth">{file.avatar ? <img src={`https://cliqestimatebuilder.com/waiver_admin/${file.avatar}`} /> : null}</td> */}
                          <td>{file.name}</td>
                          <td>{file.email}</td>
                          <td className="btnsWidth">
                            {selectedFiles.includes(file.file_name) ? (
                              <>
                                <Link
                                  to={{
                                    pathname: `/create-form/${file.id}`,
                                    state: {fileData: file},
                                  }}
                                  className="createBtn">
                                  Create Form
                                </Link>
                              </>
                            ) : null}
                            <button>
                              <Link
                                to={{
                                  pathname: `/users/${file.id}`,
                                  state: {fileData: file},
                                }}>
                                <img src={EditIcon} alt="" />
                              </Link>
                            </button>
                            <button>
                              <Link to="" onClick={() => handleRemoveClick(index, file.id)}>
                                <img src={removeIcon} alt="" />
                              </Link>
                            </button>
                            {Number(file?.status) === 1 ? (
                              <button onClick={() => handleDeactivateStatusClick(index, file.id)} className="createBtn userBtn">
                                {/* <img src={removeIcon} alt="Remove" /> */}
                                Deactivate
                              </button>
                            ) : (
                              <button onClick={() => handleActiveStatusClick(index, file.id)} className="createBtn userBtn">
                                {/* <img src={removeIcon} alt="Remove" /> */}
                                Activate
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tr>
                      <td colSpan={6} className="clsPan">
                        <span class="lgnStatus">Users Not Found</span>
                      </td>
                    </tr>
                  )}
                </table>
              </div>
              {showConfirmationModal ? (
                <div className="confirmation-modal">
                  <div className="modal-content">
                    <p>Are you sure you want to delete this user?</p>
                    <div className="modal-buttons">
                      <button onClick={() => deleteUser()}>Yes</button>
                      <button onClick={() => setShowConfirmationModal(false)}>Cancel</button>
                    </div>
                  </div>
                </div>
              ) : null}
              {showActiveStatusModal ? (
                <div className="confirmation-modal">
                  <div className="modal-content">
                    <p>Are you sure you want to activate this user?</p>
                    <div className="modal-buttons">
                      <button onClick={() => activateUser()}>Yes</button>
                      <button onClick={() => setShowActiveStatusModal(false)}>Cancel</button>
                    </div>
                  </div>
                </div>
              ) : null}
              {showDeactiveStatusModal ? (
                <div className="confirmation-modal">
                  <div className="modal-content">
                    <p>Are you sure you want to deactivate this user?</p>
                    <div className="modal-buttons">
                      <button onClick={() => deactivateUser()}>Yes</button>
                      <button onClick={() => setShowDeactiveStatusModal(false)}>Cancel</button>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            {showPagination ? (
              <div className="paginationDiv">
                <ul>
                  {Array.from({length: totalPages}, (_, index) => (
                    <li key={index}>
                      <Link to="#" className={currentPage === index + 1 ? "active" : ""} onClick={() => handlePageChange(index + 1)}>
                        {index + 1}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUsers;
